import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import Modal from "react-bootstrap/Modal";
import { BrowserRouter as Router } from 'react-router-dom'

import Tooltip from "./components/tooltip";
import Item from "./components/item";
import Selection from "./components/selection";
import BisList from "./components/bislist";
import Banner from "./components/banner";

import "./styles.css";
import "./wowhead.css";

import wow_classic_logo from "./img/wow_classic.jpg";
import discord_logo from "./img/discord.png";
import wt_logo from "./img/wtfooterlogo.png";
import bc_logo from "./img/bchat1.png";
import twink_logo from "./img/twinktool.png"

function GetIdItemsFromSet(currentSet) {
  for (var i = 0; i < BisList.data.length; i++) {
    if (BisList.data[i].id == currentSet) {
      return BisList.data[i];
    }
  }
  var defaultitem = {
    id: 0,
    faction: "",
    wowclass: "",
    wowspec: "",
    name: "",
    stage: 0,
    head_item: 0,
    neck_item: 0,
    shoulder_item: 0,
    back_item: 0,
    chest_item: 0,
    wrist_item: 0,
    hand_item: 0,
    waist_item: 0,
    leg_item: 0,
    foot_item: 0,
    finger1_item: 0,
    finger2_item: 0,
    trinket1_item: 0,
    trinket2_item: 0,
    mainhand_item: 0,
    offhand_item: 0,
    range_item: 0,
    head_enchant: 0,
    shoulder_enchant: 0,
    back_enchant: 0,
    chest_enchant: 0,
    wrist_enchant: 0,
    hand_enchant: 0,
    leg_enchant: 0,
    feet_enchant: 0,
    mainhand_enchant: 0,
    offhand_enchant: 0,
    range_enchant: 0
  };
  return defaultitem;
}

ReactGA.initialize("UA-137996462-1");
ReactGA.pageview("/homepage");

class App extends React.Component {
  state = {
    itemSetId: null
  };
  setitemSet(id) {
    Tooltip.setTooltip(null);
    this.setState({ itemSetId: id });
  }
  constructor(props) {
    super(props);
    this.state = {
      itemSetId: null,
      showCreditsModal: false,
      showUsefullWebsitesModal: false
    };
    this.setitemSet = this.setitemSet.bind(this);
    this.handleShowCreditsModal = this.handleShowCreditsModal.bind(this);
    this.handleCloseCreditsModal = this.handleCloseCreditsModal.bind(this);
  }
  handleCloseCreditsModal() {
    this.setState({ showCreditsModal: false });
  }
  handleShowCreditsModal() {
    this.setState({ showCreditsModal: true });
  }
  componentDidMount() {
    window['nitroAds'].createAd('topbanner', {
      "refreshLimit": 10,
      "refreshTime": 30,
      "renderVisibleOnly": false,
      "refreshVisibleOnly": true,
      "sizes": [
        [
          "728",
          "90"
        ]
      ],
      "report": {
        "enabled": true,
        "wording": "Report Ad",
        "position": "top-right"
      },
      "mediaQuery": "(min-width: 1025px), (min-width: 768px) and (max-width: 1024px)"
    });
    window['nitroAds'].createAd('mobiletopbanner', {
      "refreshLimit": 10,
      "refreshTime": 30,
      "renderVisibleOnly": false,
      "refreshVisibleOnly": true,
      "sizes": [
        [
          "320",
          "50"
        ]
      ],
      "report": {
        "enabled": true,
        "wording": "Report Ad",
        "position": "top-right"
      },
      "mediaQuery": "(min-width: 320px) and (max-width: 767px)"
    });
    window['nitroAds'].createAd('stickysidebar', {
      "refreshLimit": 10,
      "refreshTime": 30,
      "format": "rail",
      "rail": "left",
      "railOffsetTop": 0,
      "railOffsetBottom": 0,
      "railCollisionWhitelist": [],
      "sizes": [
        [
          "300",
          "250"
        ],
        [
          "160",
          "600"
        ],
        [
          "300",
          "600"
        ]
      ],
      "report": {
        "enabled": true,
        "wording": "Report Ad",
        "position": "top-right"
      },
      "mediaQuery": "(min-width: 1025px)"
    });
    window['nitroAds'].createAd('videoslider', {
      "format": "video-ac",
      "mediaQuery": "(min-width: 1025px)"
    });
  }
  render() {
    const { itemSetId } = this.state;
    var itemset = GetIdItemsFromSet(itemSetId);
    return (
      <div className="App">
        <div className="BisList">
          <div className="BisListTitle">
            <img
              src={wow_classic_logo}
              alt="World of Warcraft classic - Best in Slot (BiS)"
              className="classicLogo"
            />
          </div>
          <div id="topbanner" />
          <div id="mobiletopbanner" />
          <div className="row">
            <Router>
              <Selection setItemSet={this.setitemSet} />
            </Router>
			<Banner wowspec={itemset.wowspec} wowclass={itemset.wowclass} />
			<div className="BissListBottom">
            <Item
              slot="mainhand_item"
              item_id={itemset.mainhand_item}
              enchant_id={itemset.mainhand_enchant}
            />
            <Item
              slot="offhand_item"
              item_id={itemset.offhand_item}
              enchant_id={itemset.offhand_enchant}
            />
            <Item
              slot="range_item"
              item_id={itemset.range_item}
              enchant_id={itemset.range_enchant}
            />
			</div>
            <div className="BisListLeft">
              <Item
                slot="head_item"
                item_id={itemset.head_item}
                enchant_id={itemset.head_enchant}
              />
              <Item slot="neck_item" item_id={itemset.neck_item} />
              <Item
                slot="shoulder_item"
                item_id={itemset.shoulder_item}
                enchant_id={itemset.shoulder_enchant}
              />
              <Item
                slot="back_item"
                item_id={itemset.back_item}
                enchant_id={itemset.back_enchant}
              />
              <Item
                slot="chest_item"
                item_id={itemset.chest_item}
                enchant_id={itemset.chest_enchant}
              />
              <Item
                slot="wrist_item"
                item_id={itemset.wrist_item}
                enchant_id={itemset.wrist_enchant}
              />
            </div>
            <div className="BisListCenter">
              <Tooltip />
            </div>
            <div className="BisListRight">
              <Item
                slot="hand_item"
                item_id={itemset.hand_item}
                enchant_id={itemset.hand_enchant}
              />
              <Item slot="waist_item" item_id={itemset.waist_item} />
              <Item
                slot="leg_item"
                item_id={itemset.leg_item}
                enchant_id={itemset.leg_enchant}
              />
              <Item
                slot="foot_item"
                item_id={itemset.foot_item}
                enchant_id={itemset.foot_enchant}
              />
              <div className="BisListFingers">
                <Item slot="finger1_item" item_id={itemset.finger1_item} />
                <Item slot="finger2_item" item_id={itemset.finger2_item} />
              </div>
              <div className="BisListTrinkets">
                <Item slot="trinket1_item" item_id={itemset.trinket1_item} />
                <Item slot="trinket2_item" item_id={itemset.trinket2_item} />
              </div>
            </div>
          </div>
        </div>
        <div className="Footer">
          <br />
          <a href="https://www.warcrafttavern.com/guides/" target="_blank">
            Guides
          </a>{" "}
          •{" "}
          <a href="https://www.warcrafttavern.com/loot/" target="_blank">
            Dungeon Loot
          </a>{" "}
          •{" "}
          <a
            href="https://www.warcrafttavern.com/wow-classic-tools/"
            target="_blank"
          >
            Tools{" "}
          </a>{" "}
          •{" "}
          <a
            href="https://www.warcrafttavern.com/wow-classic-dps-rankings/"
            target="_blank"
          >
            DPS Rankings
          </a>
          <br />
          <br />
          <a href="https://www.warcrafttavern.com/" target="_blank">
            <img src={wt_logo} alt="Warcraft Tavern - WoW Classic News" />
          </a>
          <a href="https://barrens.chat/" target="_blank">
            <img
              src={bc_logo}
              alt="Barrens Chat • A WoW Classic Discussion Forum"
            />
          </a>
          <a href="https://www.wowclassicbis.com/twink" target="_blank" style={{marginLeft: '8px'}}>
            <img src={twink_logo} alt="WoW Classic Twink Best in Slot" />
          </a>
          <br />
          <br />
          Copyright © Classic WoW BiS 2019-2020 |{" "}
          <span className="spanLink" onClick={this.handleShowCreditsModal}>
            Credits
          </span>
        </div>
        <div id="videoslider" />
        <Modal
          show={this.state.showCreditsModal}
          onHide={this.handleCloseCreditsModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Credits</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>BiS Lists</h4>
            <p>
              Bis Lists are from pingaan's sheets.
              <br />
              Discord - pingaan#5396
              <br />
              <a
                href="https://www.reddit.com/r/classicwow/comments/asfpne/bislist_for_every_stage_release_naxxramasall/"
                target="_blank"
              >
                Reddit post here
              </a>
              <br />
              <a
                href="https://docs.google.com/spreadsheets/d/10IV_3NEmZdhh8iQXrs2Ek77YyUJbjBMWO5UxIWLlZl0/edit?usp=sharing"
                target="_blank"
              >
                Google docs spreadsheets here
              </a>
            </p>
            <h4>Tooltips and images</h4>
            <p>
              Tooltips and images are from{" "}
              <a href="http://classic.wowhead.com" target="_blank">
                classic.wowhead.com
              </a>
            </p>
            <h4>Game</h4>
            <p>
              World of warcraft and everything related to the game are from
              Blizzard.
            </p>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
